module.exports = __webpack_public_path__ + "static/img/0_1_3.57264909.jpg";